import { render, staticRenderFns } from "./StreamingDemo.vue?vue&type=template&id=d0a1e7d8&scoped=true"
import script from "./StreamingDemo.vue?vue&type=script&lang=js"
export * from "./StreamingDemo.vue?vue&type=script&lang=js"
import style0 from "./StreamingDemo.vue?vue&type=style&index=0&id=d0a1e7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a1e7d8",
  null
  
)

export default component.exports